import type {
  ClientClassificationInput,
  ComponentValueResponse,
  SaveComponentValueResponse,
} from "@repo/shared/types";
import { get, post } from "../_client";

const BASE = "/internal/flow-instances";

export function getFlowInstanceValue(instanceId: string) {
  return get<ComponentValueResponse>(
    `${BASE}/${instanceId}/client-classification/flow-instance-value`,
  );
}

export function saveFlowInstanceValue(instanceId: string, input: ClientClassificationInput) {
  return post<SaveComponentValueResponse>(
    `${BASE}/${instanceId}/client-classification/flow-instance-value`,
    input,
  );
}
